import React from 'react';

const LoadingSpinner = ({ size = 'large', message = '' }) => {
  const sizeClasses = {
    small: 'h-6 w-6 border-2',
    medium: 'h-10 w-10 border-3',
    large: 'h-16 w-16 border-4',
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className={`${sizeClasses[size]} border-teal-600 border-t-transparent rounded-full animate-spin`}
      ></div>
      {message && (
        <p className="mt-4 text-slate-600 text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;